// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"PropertyInlineLabel__tooltip__y2Dz8","popover":"PropertyInlineLabel__popover__QDJKG"};